'use strict';

var _ = require('lodash');
var ConfigurationUserDefinedRefDataMarketTransformerFactory = function ConfigurationUserDefinedRefDataMarketTransformerFactory(DataTransformer) {
  var DTD_ROWS_NUMBER = 366;
  function ConfigurationUserDefinedRefDataMarketTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-user-defined-ref-data-market-mode';
    this.priority = 1;
  }
  ConfigurationUserDefinedRefDataMarketTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationUserDefinedRefDataMarketTransformer.constructor = ConfigurationUserDefinedRefDataMarketTransformer;
  ConfigurationUserDefinedRefDataMarketTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationUserDefinedRefDataMarketTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationUserDefinedRefDataMarketTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationUserDefinedRefDataMarketTransformer.prototype.transform = function (data) {
    var mappedMarketMetrics = {
      BOOKINGS: 'Bookings',
      REVENUE: 'Revenue',
      YIELD: 'Yield',
      DEMAND: 'Demand',
      REGULAR_BOOKINGS: 'Regular Bookings',
      REGULAR_REVENUE: 'Regular Revenue',
      REGULAR_YIELD: 'Regular Yield',
      REGULAR_DEMAND: 'Regular FC Demand',
      MAPPED_BOOKINGS: 'Mapped Bookings',
      MAPPED_REVENUE: 'Mapped Revenue',
      MAPPED_YIELD: 'Mapped Yield',
      MAPPED_DEMAND: 'Mapped FC Demand'
    };
    function changeReferenceMetricToDisplay(referenceMetric) {
      return mappedMarketMetrics[referenceMetric];
    }
    function generateEmptyDtds() {
      return _.times(DTD_ROWS_NUMBER, function (index) {
        return {
          DTD: index,
          AVG: '',
          MAX: '',
          MIN: ''
        };
      });
    }
    function createUrdRow(attributes, status) {
      return {
        marketEntity: attributes.marketEntity,
        market: _.isUndefined(attributes.origin) || _.isUndefined(attributes.destination) ? '' : attributes.origin + '-' + attributes.destination,
        pos: attributes.pos,
        marketProduct: attributes.marketProduct,
        demandSeason: attributes.season,
        dowGroup: attributes.dayOfWeekGroup,
        referenceMetric: changeReferenceMetricToDisplay(attributes.referenceMetric),
        status: status,
        dtds: []
      };
    }
    if (_.isEmpty(data.domain.hepList)) {
      return [];
    }
    return _.transform(data.domain.hepList, function (result, item) {
      var statusTypes = _.groupBy(item.properties.profile.functionLevelURDs, 'statusType');
      if (Object.keys(statusTypes).length === 0) {
        var emptyRow = createUrdRow(item.attributes, 'DISABLED');
        emptyRow.dtds = generateEmptyDtds();
        result.push(emptyRow);
      }
      _.forEach(_.keys(statusTypes), function (type) {
        var row = createUrdRow(item.attributes, type);
        _.forEach(statusTypes[type], function (level) {
          _.forEach(level.metricValuesCorrespondingToDTD, function (value, index) {
            if (_.isUndefined(row.dtds[index])) {
              row.dtds[index] = {
                DTD: index
              };
            }
            row.dtds[index][level.functionType] = value;
          });
        });
        result.push(row);
      });
    });
  };
  return ConfigurationUserDefinedRefDataMarketTransformer;
};
ConfigurationUserDefinedRefDataMarketTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = ConfigurationUserDefinedRefDataMarketTransformerFactory;